import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Select, Spin} from 'antd'
import {debounce} from 'throttle-debounce'

import style from './tickers.sass'

@inject('store') @observer
class TickersInput extends Component {
  search = debounce(500, (value) => {
    const {type} = this.props
    this.props.store.symbols.search(value, type)
  })
  handleChange = (values) => {
    this.props.changeHandler(values)
    const {type} = this.props
    this.props.store.symbols.search('', type)
  }
  handleFocus = () => {
    const {type} = this.props
    this.props.store.symbols.search('', type)
  }
  render() {
    const {list, loading} = this.props.store.symbols
    const {tickers} = this.props
    return(
      <Select
        mode='multiple'
        size='large'
        filterOption={false}
        optionLabelProp='label'
        notFoundContent={loading ? <Spin size='small'/> : null}
        value={tickers}
        onSearch={this.search}
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        styleName='wrapper'
      >
        {list.map(item => <Select.Option key={item.symbol} value={item.symbol} label={item.symbol.replace('CRYPTO-', '')}>
          {item.symbol.replace('CRYPTO-', '')}
          {item.symbol_name && item.symbol !== item.symbol_name ? ` - ${item.symbol_name}` : ''}
        </Select.Option>)}
      </Select>
    )
  }
}

export default TickersInput
